export default "__VITE_ASSET__DjRVZr6s__"